export const clipTypes = {
  0: 'none',
  1: 'video',
  2: 'live',
  3: 'video + live'
} as $Lns.ObjectKey;
